import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { NoImageFilledIcon } from "@gemini/icons";
export const AdFallbackIcon = () => {
    return (_jsx(Box, { position: "absolute", children: _jsx(NoImageFilledIcon, { color: "color.background.backdrop.default" }) }));
};
